import { useEffect, useState } from "react";
import { Square, Volume2 } from "lucide-react";
import { t } from "@/i18n";
import { hueySpeak, onVoiceChange, stopHuey, voiceState } from "@/lib/voice";

// Tracks which Huey utterance is currently playing (shared across all buttons). Returns the id or null.
export const useSpeaking = () => {
  const [state, setState] = useState(voiceState);
  useEffect(() => onVoiceChange(setState), []);
  return state?.id || null;
};

export const useVoiceState = () => {
  const [state, setState] = useState(voiceState);
  useEffect(() => onVoiceChange(setState), []);
  return state;
};

export const SpeakButton = ({ id, text, className = "", testid }) => {
  const speaking = useSpeaking() === id;
  const toggle = (e) => { e.stopPropagation(); if (speaking) stopHuey(); else hueySpeak(id, text); };
  return (
    <button onClick={toggle} aria-pressed={speaking} aria-label={speaking ? t("huey_stop_reading") : t("huey_read_aloud")} title={speaking ? t("huey_stop_reading") : t("huey_read_aloud")}
      data-testid={testid || `huey-speak-${id}`} data-speaking={speaking}
      className={`shrink-0 w-7 h-7 rounded-full border-2 flex items-center justify-center transition-colors ${speaking ? "bg-[#FF5252] border-[#1E293B] text-white" : "bg-white border-slate-200 text-slate-500 hover:border-[#1E293B] hover:text-[#1E293B]"} ${className}`}>
      {speaking ? <Square className="w-3 h-3" /> : <Volume2 className="w-3.5 h-3.5" />}
    </button>
  );
};
